import axios from './axios'

class exchange {
  // 兑换邀请码
  toExchange(code) {
    const url = '/Resource/Invatation/exchange'
    return axios.post(url, { code: code })
  }
  /***
   * 直播领福利
   */
  getHistory() {
    const url = '/Resource/Invatation/history'
    return axios.post(url, {})
  }
}

export default new exchange()
